import React, { Component } from 'react';
import '../../../../styles/scss/style.css';

//Components
import Image from '../../atoms/Image';
import logoImage from '../../../../images/logo_bubble_blue.svg';

//Returning the component
class LoadingScreen extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: this.props.loading
		}
	}
	componentWillReceiveProps(nextProps) {
		this.setState({ loading: nextProps.loading });
	}
	render() {
		return (
			<div className={`loadingScreen ${this.state.loading ? 'loadingScreen--active' : ''}`}>
				<div className="loadingscreen__imageWrapper">
					<Image alt="Frankie Logo" src={logoImage} />
				</div>
			</div>
		)
	}
}

//Default properties if they are not set
LoadingScreen.defaultProps = {
	class: ""
};

export default LoadingScreen;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/LoadingScreen/LoadingScreen.jsx